var Mutex = function() {
    this._busy  = false;
    this._queue = [];
  };
  
  // Mutex.prototype.synchronize = function(task) {
  //   this._queue.push(task);
  //   if (!this._busy) {
  //       console.log("blahbusynot");
  //       this._dequeue();
  //   }
  //   else {
  //       console.log("blahbusy");
  //   }
  // };
  
  Mutex.prototype.synchronize = function(task) {
    var self = this;

    return new Promise(function(resolve, reject) {
      self._queue.push([task, resolve, reject]);
      if (!self._busy) self._dequeue();
    });
  };
  
  Mutex.prototype._dequeue = function() {
    this._busy = true;
    var next = this._queue.shift();
    console.log("blahdeqeue");
  
    if (next)
      this._execute(next);
    else
      this._busy = false;
  };
  
  // Mutex.prototype._execute = function(task) {
  //   var self = this;
  //   console.log("blahexecute");
  
  //   task().then(function() {
  //     self._dequeue();
  //   }, function() {
  //     self._dequeue();
  //   });
  // };

  
  Mutex.prototype._execute = function(record) {
    var task    = record[0],
        resolve = record[1],
        reject  = record[2],
        self    = this;

    task().then(resolve, reject).then(function() {
      self._dequeue();
    });
  };

module.exports = Mutex;